// extracted by mini-css-extract-plugin
export default {"verification":"index_verification__Uef8V"};